// Legacy conflict summary table only; the v2 table renders these columns from the v3
// endpoint's resolved `sce` payload. Keep in sync with packages/api/src/common/sceInfoConfig.ts,
// the server-side copy that powers v3 sort/filter/export and that payload.
const sceData: { [key: string]: { [key: string]: string } } = {
  '2034970': {
    Program: 'Palisades Rebuild',
    PIF: '535020',
    TD: '2034970',
    Circuit: 'NICHOLAS',
    Leader: 'Humberto Bocanegra',
    Region: 'North Coast',
    'Work Type': 'UG Install',
    'UG Miles': '0.45',
    'OH DE Miles': '0.23',
  },
  '2068576': {
    Program: '2025 TUG',
    PIF: '535024',
    TD: '2068576',
    Circuit: 'HOOLIGAN',
    Leader: 'Robert Flannery',
    Region: 'North Coast',
    'Work Type': 'UG Install',
    'UG Miles': '1.37',
    'OH DE Miles': '1.24',
  },
  '2122888': {
    Program: '2025 TUG',
    PIF: '535024',
    TD: '2122888',
    Circuit: 'HOOLIGAN',
    Leader: 'Robert Flannery',
    Region: 'North Coast',
    'Work Type': 'UG Install',
    'UG Miles': '0.43',
    'OH DE Miles': '0.21',
  },
  '2152533': {
    Program: 'Palisades Rebuild',
    PIF: '535020',
    TD: '2152533',
    Circuit: 'NICHOLAS',
    Leader: 'Vince Cichoski',
    Region: 'North Coast',
    'Work Type': 'UG Install',
    'UG Miles': '1.16',
    'OH DE Miles': '0.69',
  },
  '2153000': {
    Program: '2025 TUG',
    PIF: '635045',
    TD: '2153000',
    Circuit: 'BORCHARD',
    Leader: 'Robert Flannery',
    Region: 'North Coast',
    'Work Type': 'UG Install',
    'UG Miles': '0.56',
    'OH DE Miles': '0.46',
  },
  '2153294': {
    Program: 'Palisades Rebuild',
    PIF: '535020',
    TD: '2153294',
    Circuit: 'NICHOLAS',
    Leader: 'Vince Cichoski',
    Region: 'North Coast',
    'Work Type': 'UG Install',
    'UG Miles': '1.21',
    'OH DE Miles': '0.69',
  },
  '2153300': {
    Program: 'Palisades Rebuild',
    PIF: '535020',
    TD: '2153300',
    Circuit: 'NICHOLAS',
    Leader: 'Vince Cichoski',
    Region: 'North Coast',
    'Work Type': 'UG Install',
    'UG Miles': '0.56',
    'OH DE Miles': '0.11',
  },
  '2153316': {
    Program: 'Palisades Rebuild',
    PIF: '535020',
    TD: '2153316',
    Circuit: 'NICHOLAS',
    Leader: 'Vince Cichoski',
    Region: 'North Coast',
    'Work Type': 'UG Install',
    'UG Miles': '0.68',
    'OH DE Miles': '0.55',
  },
  '2163041': {
    Program: 'Palisades Rebuild',
    PIF: '635046',
    TD: '2163041',
    Circuit: 'NICHOLAS',
    Leader: 'Robert Flannery',
    Region: 'North Coast',
    'Work Type': 'UG Install',
    'UG Miles': '1.90',
    'OH DE Miles': '0.96',
  },
  '2176373': {
    Program: 'Palisades Rebuild',
    PIF: '635047',
    TD: '2176373',
    Circuit: 'VICASA',
    Leader: 'Robert Flannery',
    Region: 'North Coast',
    'Work Type': 'UG Install',
    'UG Miles': '0.91',
    'OH DE Miles': '0.00',
  },
  '2183060': {
    Program: 'Palisades Rebuild',
    PIF: '635046',
    TD: '2183060',
    Circuit: 'NICHOLAS',
    Leader: 'Vince Cichoski',
    Region: 'North Coast',
    'Work Type': 'UG Install',
    'UG Miles': '0.71',
    'OH DE Miles': '0.55',
  },
  '2183061': {
    Program: 'Palisades Rebuild',
    PIF: '635046',
    TD: '2183061',
    Circuit: 'NICHOLAS',
    Leader: 'Vince Cichoski',
    Region: 'North Coast',
    'Work Type': 'UG Install',
    'UG Miles': '1.54',
    'OH DE Miles': '0.96',
  },
  '2183062': {
    Program: 'Palisades Rebuild',
    PIF: '635046',
    TD: '2183062',
    Circuit: 'NICHOLAS',
    Leader: 'Vince Cichoski',
    Region: 'North Coast',
    'Work Type': 'UG Install',
    'UG Miles': '0.40',
    'OH DE Miles': '0.42',
  },
  '2183063': {
    Program: 'Palisades Rebuild',
    PIF: '635046',
    TD: '2183063',
    Circuit: 'NICHOLAS',
    Leader: 'Robert Flannery',
    Region: 'North Coast',
    'Work Type': 'UG Install',
    'UG Miles': '0.38',
    'OH DE Miles': '0.42',
  },
  '2183064': {
    Program: 'Palisades Rebuild',
    PIF: '635046',
    TD: '2183064',
    Circuit: 'NICHOLAS',
    Leader: 'Robert Flannery',
    Region: 'North Coast',
    'Work Type': 'UG Install',
    'UG Miles': '1.29',
    'OH DE Miles': '0.89',
  },
  '2187857': {
    Program: 'Palisades Rebuild',
    PIF: '635047',
    TD: '2187857',
    Circuit: 'VICASA',
    Leader: 'Robert Flannery',
    Region: 'North Coast',
    'Work Type': 'UG Install',
    'UG Miles': '0.81',
    'OH DE Miles': '0.00',
  },
  '2203857': {
    Program: '2025 TUG',
    PIF: '535024',
    TD: '2203857',
    Circuit: 'HOOLIGAN',
    Leader: 'Robert Flannery',
    Region: 'North Coast',
    'Work Type': 'UG Install',
    'UG Miles': '0.08',
    'OH DE Miles': '0.07',
  },
  '2211625': {
    Program: '2025 TUG',
    PIF: '635045',
    TD: '2211625',
    Circuit: 'BORCHARD',
    Leader: 'Robert Flannery',
    Region: 'North Coast',
    'Work Type': 'UG Install',
    'UG Miles': '0.20',
    'OH DE Miles': '0.14',
  },
  '2226000': {
    Program: 'Palisades Rebuild',
    PIF: '535020',
    TD: '2226000',
    Circuit: 'NICHOLAS',
    Leader: 'Vince Cichoski',
    Region: 'North Coast',
    'Work Type': 'UG Install',
    'UG Miles': '0.99',
    'OH DE Miles': '0.59',
  },
  '2226049': {
    Program: 'Palisades Rebuild',
    PIF: '535020',
    TD: '2226049',
    Circuit: 'NICHOLAS',
    Leader: 'Vince Cichoski',
    Region: 'North Coast',
    'Work Type': 'UG Install',
    'UG Miles': '0.37',
    'OH DE Miles': '0.05',
  },
  '2226050': {
    Program: 'Palisades Rebuild',
    PIF: '535020',
    TD: '2226050',
    Circuit: 'NICHOLAS',
    Leader: 'Vince Cichoski',
    Region: 'North Coast',
    'Work Type': 'UG Install',
    'UG Miles': '0.23',
    'OH DE Miles': '0.18',
  },
  '2227032': {
    Program: 'Palisades Rebuild',
    PIF: '535020',
    TD: '2227032',
    Circuit: 'NICHOLAS',
    Leader: 'Vince Cichoski',
    Region: 'North Coast',
    'Work Type': 'UG Install',
    'UG Miles': '0.11',
    'OH DE Miles': '0.08',
  },
  '2228005': {
    Program: 'Palisades Rebuild',
    PIF: '535020',
    TD: '2228005',
    Circuit: 'NICHOLAS',
    Leader: 'Vince Cichoski',
    Region: 'North Coast',
    'Work Type': 'UG Install',
    'UG Miles': '0.12',
    'OH DE Miles': '0.04',
  },
  '2228006': {
    Program: 'Palisades Rebuild',
    PIF: '535020',
    TD: '2228006',
    Circuit: 'NICHOLAS',
    Leader: 'Vince Cichoski',
    Region: 'North Coast',
    'Work Type': 'UG Install',
    'UG Miles': '0.17',
    'OH DE Miles': '0.06',
  },
  '2228007': {
    Program: 'Palisades Rebuild',
    PIF: '535020',
    TD: '2228007',
    Circuit: 'NICHOLAS',
    Leader: 'Vince Cichoski',
    Region: 'North Coast',
    'Work Type': 'UG Install',
    'UG Miles': '0.83',
    'OH DE Miles': '0.42',
  },
  '2228009': {
    Program: 'Palisades Rebuild',
    PIF: '535020',
    TD: '2228009',
    Circuit: 'NICHOLAS',
    Leader: 'Vince Cichoski',
    Region: 'North Coast',
    'Work Type': 'UG Install',
    'UG Miles': '1.13',
    'OH DE Miles': '0.97',
  },
  '2228010': {
    Program: 'Palisades Rebuild',
    PIF: '535020',
    TD: '2228010',
    Circuit: 'NICHOLAS',
    Leader: 'Vince Cichoski',
    Region: 'North Coast',
    'Work Type': 'UG Install',
    'UG Miles': '0.07',
    'OH DE Miles': '0.04',
  },
  '2228011': {
    Program: 'Palisades Rebuild',
    PIF: '535020',
    TD: '2228011',
    Circuit: 'NICHOLAS',
    Leader: 'Vince Cichoski',
    Region: 'North Coast',
    'Work Type': 'UG Install',
    'UG Miles': '0.59',
    'OH DE Miles': '0.45',
  },
  '2235280': {
    Program: 'Eaton Rebuild',
    PIF: '727140',
    TD: '2235280',
    Circuit: 'GORGE',
    Leader: 'Dean Perez',
    Region: 'Metro East',
    'Work Type': 'UG Install',
    'UG Miles': '0.85',
    'OH DE Miles': '0.00',
  },
  '2235881': {
    Program: 'Palisades Rebuild',
    PIF: '535020',
    TD: '2235881',
    Circuit: 'NICHOLAS',
    Leader: 'Vince Cichoski',
    Region: 'North Coast',
    'Work Type': 'UG Install',
    'UG Miles': '1.06',
    'OH DE Miles': '0.78',
  },
  '2235882': {
    Program: 'Palisades Rebuild',
    PIF: '535020',
    TD: '2235882',
    Circuit: 'NICHOLAS',
    Leader: 'Vince Cichoski',
    Region: 'North Coast',
    'Work Type': 'UG Install',
    'UG Miles': '0.71',
    'OH DE Miles': '0.41',
  },
  '2235884': {
    Program: 'Palisades Rebuild',
    PIF: '535020',
    TD: '2235884',
    Circuit: 'NICHOLAS',
    Leader: 'Robert Flannery',
    Region: 'North Coast',
    'Work Type': 'UG Install',
    'UG Miles': '0.37',
    'OH DE Miles': '0.10',
  },
  '2235885': {
    Program: 'Palisades Rebuild',
    PIF: '535020',
    TD: '2235885',
    Circuit: 'NICHOLAS',
    Leader: 'Vince Cichoski',
    Region: 'North Coast',
    'Work Type': 'UG Install',
    'UG Miles': '0.13',
    'OH DE Miles': '0.04',
  },
  '2235886': {
    Program: 'Palisades Rebuild',
    PIF: '535020',
    TD: '2235886',
    Circuit: 'NICHOLAS',
    Leader: 'Vince Cichoski',
    Region: 'North Coast',
    'Work Type': 'UG Install',
    'UG Miles': '0.61',
    'OH DE Miles': '0.56',
  },
  '2235887': {
    Program: 'Palisades Rebuild',
    PIF: '535020',
    TD: '2235887',
    Circuit: 'NICHOLAS',
    Leader: 'Robert Flannery',
    Region: 'North Coast',
    'Work Type': 'UG Install',
    'UG Miles': '0.57',
    'OH DE Miles': '0.26',
  },
  '2235888': {
    Program: 'Palisades Rebuild',
    PIF: '535020',
    TD: '2235888',
    Circuit: 'NICHOLAS',
    Leader: 'Vince Cichoski',
    Region: 'North Coast',
    'Work Type': 'UG Install',
    'UG Miles': '0.28',
    'OH DE Miles': '0.17',
  },
  '2235889': {
    Program: 'Palisades Rebuild',
    PIF: '535020',
    TD: '2235889',
    Circuit: 'NICHOLAS',
    Leader: 'Vince Cichoski',
    Region: 'North Coast',
    'Work Type': 'UG Install',
    'UG Miles': '0.96',
    'OH DE Miles': '0.65',
  },
  '2235890': {
    Program: 'Palisades Rebuild',
    PIF: '535020',
    TD: '2235890',
    Circuit: 'NICHOLAS',
    Leader: 'Vince Cichoski',
    Region: 'North Coast',
    'Work Type': 'UG Install',
    'UG Miles': '0.14',
    'OH DE Miles': '0.11',
  },
  '2235891': {
    Program: 'Palisades Rebuild',
    PIF: '535020',
    TD: '2235891',
    Circuit: 'NICHOLAS',
    Leader: 'Vince Cichoski',
    Region: 'North Coast',
    'Work Type': 'UG Install',
    'UG Miles': '1.02',
    'OH DE Miles': '0.68',
  },
  '2235892': {
    Program: 'Palisades Rebuild',
    PIF: '535020',
    TD: '2235892',
    Circuit: 'NICHOLAS',
    Leader: 'Vince Cichoski',
    Region: 'North Coast',
    'Work Type': 'UG Install',
    'UG Miles': '0.83',
    'OH DE Miles': '0.42',
  },
  '2242711': {
    Program: 'Palisades Rebuild',
    PIF: '535020',
    TD: '2242711',
    Circuit: 'NICHOLAS',
    Leader: 'Vince Cichoski',
    Region: 'North Coast',
    'Work Type': 'UG Install',
    'UG Miles': '0.20',
    'OH DE Miles': '0.09',
  },
  '2249634': {
    Program: 'Palisades Rebuild',
    PIF: '535020',
    TD: '2249634',
    Circuit: 'NICHOLAS',
    Leader: 'Robert Flannery',
    Region: 'North Coast',
    'Work Type': 'UG Install',
    'UG Miles': '0.11',
    'OH DE Miles': '0.08',
  },
  '2249635': {
    Program: 'Palisades Rebuild',
    PIF: '535020',
    TD: '2249635',
    Circuit: 'NICHOLAS',
    Leader: 'Robert Flannery',
    Region: 'North Coast',
    'Work Type': 'UG Install',
    'UG Miles': '0.07',
    'OH DE Miles': '0.03',
  },
  '2255185': {
    Program: 'Palisades Rebuild',
    PIF: '535020',
    TD: '2255185',
    Circuit: 'NICHOLAS',
    Leader: 'Vince Cichoski',
    Region: 'North Coast',
    'Work Type': 'UG Install',
    'UG Miles': '0.40',
    'OH DE Miles': '0.37',
  },
  '2255186': {
    Program: 'Palisades Rebuild',
    PIF: '535020',
    TD: '2255186',
    Circuit: 'NICHOLAS',
    Leader: 'Vince Cichoski',
    Region: 'North Coast',
    'Work Type': 'UG Install',
    'UG Miles': '0.04',
    'OH DE Miles': '0.00',
  },
  '2256399': {
    Program: 'Palisades Rebuild',
    PIF: '535020',
    TD: '2256399',
    Circuit: 'NICHOLAS',
    Leader: 'Vince Cichoski',
    Region: 'North Coast',
    'Work Type': 'UG Install',
    'UG Miles': '0.16',
    'OH DE Miles': '0.05',
  },
  '2256400': {
    Program: 'Palisades Rebuild',
    PIF: '535020',
    TD: '2256400',
    Circuit: 'NICHOLAS',
    Leader: 'Vince Cichoski',
    Region: 'North Coast',
    'Work Type': 'UG Install',
    'UG Miles': '0.29',
    'OH DE Miles': '0.04',
  },
  '2256401': {
    Program: 'Palisades Rebuild',
    PIF: '535020',
    TD: '2256401',
    Circuit: 'NICHOLAS',
    Leader: 'Robert Flannery',
    Region: 'North Coast',
    'Work Type': 'UG Install',
    'UG Miles': '0.70',
    'OH DE Miles': '0.54',
  },
  '2260198': {
    Program: 'Palisades Rebuild',
    PIF: '535020',
    TD: '2260198',
    Circuit: 'NICHOLAS',
    Leader: 'Vince Cichoski',
    Region: 'North Coast',
    'Work Type': 'UG Install',
    'UG Miles': '0.66',
    'OH DE Miles': '0.41',
  },
  '2260199': {
    Program: 'Palisades Rebuild',
    PIF: '535020',
    TD: '2260199',
    Circuit: 'NICHOLAS',
    Leader: 'Vince Cichoski',
    Region: 'North Coast',
    'Work Type': 'UG Install',
    'UG Miles': '0.23',
    'OH DE Miles': '0.00',
  },
  '2273015': {
    Program: 'Palisades Rebuild',
    PIF: '45242',
    TD: '2273015',
    Circuit: 'VICASA',
    Leader: 'Humberto Bocanegra',
    Region: 'North Coast',
    'Work Type': 'UG Install',
    'UG Miles': '0.45',
    'OH DE Miles': '0.63',
  },
  '2287892': {
    Program: 'Palisades Rebuild',
    PIF: '635046',
    TD: '2287892',
    Circuit: 'NICHOLAS',
    Leader: 'Robert Flannery',
    Region: 'North Coast',
    'Work Type': 'UG Install',
    'UG Miles': '0.61',
    'OH DE Miles': '0.26',
  },
  '2291492': {
    Program: 'Palisades Rebuild',
    PIF: '635046',
    TD: '2291492',
    Circuit: 'NICHOLAS',
    Leader: 'Robert Flannery',
    Region: 'North Coast',
    'Work Type': 'UG Install',
    'UG Miles': '1.11',
    'OH DE Miles': '0.94',
  },
  '2300265': {
    Program: 'Palisades Rebuild',
    PIF: '535020',
    TD: '2300265',
    Circuit: 'NICHOLAS',
    Leader: 'Vince Cichoski',
    Region: 'North Coast',
    'Work Type': 'UG Install',
    'UG Miles': '0.15',
    'OH DE Miles': '0.12',
  },
  '2300451': {
    Program: 'Palisades Rebuild',
    PIF: '635046',
    TD: '2300451',
    Circuit: 'NICHOLAS',
    Leader: 'Robert Flannery',
    Region: 'North Coast',
    'Work Type': 'UG Install',
    'UG Miles': '0.85',
    'OH DE Miles': '0.46',
  },
  '2302334': {
    Program: 'Palisades Rebuild',
    PIF: '635046',
    TD: '2302334',
    Circuit: 'NICHOLAS',
    Leader: 'Robert Flannery',
    Region: 'North Coast',
    'Work Type': 'UG Install',
    'UG Miles': '0.12',
    'OH DE Miles': '0.40',
  },
  '2304830': {
    Program: 'Eaton Rebuild',
    PIF: '727140',
    TD: '2304830',
    Circuit: 'GORGE',
    Leader: 'Dina Mendoza',
    Region: 'Metro East',
    'Work Type': 'UG Install',
    'UG Miles': '0.89',
    'OH DE Miles': '0.00',
  },
  '2305011': {
    Program: 'Palisades Rebuild',
    PIF: '635046',
    TD: '2305011',
    Circuit: 'NICHOLAS',
    Leader: 'Robert Flannery',
    Region: 'North Coast',
    'Work Type': 'UG Install',
    'UG Miles': '0.15',
    'OH DE Miles': '0.00',
  },
  '2308200': {
    Program: 'Palisades Rebuild',
    PIF: '45242',
    TD: '2308200',
    Circuit: 'VICASA',
    Leader: 'Humberto Bocanegra',
    Region: 'North Coast',
    'Work Type': 'UG Install',
    'UG Miles': '0.90',
    'OH DE Miles': '1.28',
  },
  '2322978': {
    Program: 'Palisades Rebuild',
    PIF: '635046',
    TD: '2322978',
    Circuit: 'NICHOLAS',
    Leader: 'Vince Cichoski',
    Region: 'North Coast',
    'Work Type': 'UG Install',
    'UG Miles': '0.16',
    'OH DE Miles': '0.09',
  },
  '2352201': {
    Program: 'Palisades Rebuild',
    PIF: '535020',
    TD: '2352201',
    Circuit: 'NICHOLAS',
    Leader: 'Vince Cichoski',
    Region: 'North Coast',
    'Work Type': 'UG Install',
    'UG Miles': '0.67',
    'OH DE Miles': '0.67',
  },
  '2352217': {
    Program: 'Palisades Rebuild',
    PIF: '535020',
    TD: '2352217',
    Circuit: 'NICHOLAS',
    Leader: 'Vince Cichoski',
    Region: 'North Coast',
    'Work Type': 'UG Install',
    'UG Miles': '0.63',
    'OH DE Miles': '0.63',
  },
  '2352225': {
    Program: 'Palisades Rebuild',
    PIF: '535020',
    TD: '2352225',
    Circuit: 'NICHOLAS',
    Leader: 'Vince Cichoski',
    Region: 'North Coast',
    'Work Type': 'UG Install',
    'UG Miles': '0.79',
    'OH DE Miles': '0.79',
  },
  '2352227': {
    Program: 'Palisades Rebuild',
    PIF: '535020',
    TD: '2352227',
    Circuit: 'NICHOLAS',
    Leader: 'Vince Cichoski',
    Region: 'North Coast',
    'Work Type': 'UG Install',
    'UG Miles': '0.57',
    'OH DE Miles': '0.57',
  },
  '2363974': {
    Program: 'Palisades Rebuild',
    PIF: '535020',
    TD: '2363974',
    Circuit: 'NICHOLAS',
    Leader: 'Vince Cichoski',
    Region: 'North Coast',
    'Work Type': 'UG Install',
    'UG Miles': '0.61',
    'OH DE Miles': '0.61',
  },
  '2363981': {
    Program: 'Palisades Rebuild',
    PIF: '535020',
    TD: '2363981',
    Circuit: 'NICHOLAS',
    Leader: 'Vince Cichoski',
    Region: 'North Coast',
    'Work Type': 'UG Install',
    'UG Miles': '0.74',
    'OH DE Miles': '0.74',
  },
  '2365622': {
    Program: 'Palisades Rebuild',
    PIF: 'NA',
    TD: '2365622',
    Circuit: 'Horntoad',
    Leader: 'Vince Cichoski',
    Region: 'North Coast',
    'Work Type': 'UG Install',
    'UG Miles': '1.05',
    'OH DE Miles': '1.00',
  },
  '2367488': {
    Program: 'Palisades Rebuild',
    PIF: '535020',
    TD: '2367488',
    Circuit: 'NICHOLAS',
    Leader: 'Vince Cichoski',
    Region: 'North Coast',
    'Work Type': 'UG Install',
    'UG Miles': '0.26',
    'OH DE Miles': '0.36',
  },
  '2367494': {
    Program: 'Palisades Rebuild',
    PIF: '535020',
    TD: '2367494',
    Circuit: 'NICHOLAS',
    Leader: 'Vince Cichoski',
    Region: 'North Coast',
    'Work Type': 'UG Install',
    'UG Miles': '0.65',
    'OH DE Miles': '0.63',
  },
  '2367495': {
    Program: 'Palisades Rebuild',
    PIF: '535020',
    TD: '2367495',
    Circuit: 'NICHOLAS',
    Leader: 'Vince Cichoski',
    Region: 'North Coast',
    'Work Type': 'UG Install',
    'UG Miles': '0.20',
    'OH DE Miles': '0.20',
  },
  '2367498': {
    Program: 'Palisades Rebuild',
    PIF: '535020',
    TD: '2367498',
    Circuit: 'NICHOLAS',
    Leader: 'Vince Cichoski',
    Region: 'North Coast',
    'Work Type': 'UG Install',
    'UG Miles': '0.21',
    'OH DE Miles': '0.04',
  },
  '2367500': {
    Program: 'Palisades Rebuild',
    PIF: '535020',
    TD: '2367500',
    Circuit: 'NICHOLAS',
    Leader: 'Vince Cichoski',
    Region: 'North Coast',
    'Work Type': 'UG Install',
    'UG Miles': '0.31',
    'OH DE Miles': '0.06',
  },
  '2367502': {
    Program: 'Palisades Rebuild',
    PIF: '535020',
    TD: '2367502',
    Circuit: 'NICHOLAS',
    Leader: 'Vince Cichoski',
    Region: 'North Coast',
    'Work Type': 'UG Install',
    'UG Miles': '0.15',
    'OH DE Miles': '0.09',
  },
  '2368815': {
    Program: 'Palisades Rebuild',
    PIF: '535020',
    TD: '2368815',
    Circuit: 'NICHOLAS',
    Leader: 'Vince Cichoski',
    Region: 'North Coast',
    'Work Type': 'UG Install',
    'UG Miles': '0.01',
    'OH DE Miles': '0.05',
  },
  '2368816': {
    Program: 'Palisades Rebuild',
    PIF: '535020',
    TD: '2368816',
    Circuit: 'NICHOLAS',
    Leader: 'Vince Cichoski',
    Region: 'North Coast',
    'Work Type': 'UG Install',
    'UG Miles': '0.45',
    'OH DE Miles': '0.12',
  },
  '2368819': {
    Program: 'Palisades Rebuild',
    PIF: '535020',
    TD: '2368819',
    Circuit: 'NICHOLAS',
    Leader: 'Vince Cichoski',
    Region: 'North Coast',
    'Work Type': 'UG Install',
    'UG Miles': '0.45',
    'OH DE Miles': '0.12',
  },
  '2368821': {
    Program: 'Palisades Rebuild',
    PIF: '535020',
    TD: '2368821',
    Circuit: 'NICHOLAS',
    Leader: 'Vince Cichoski',
    Region: 'North Coast',
    'Work Type': 'UG Install',
    'UG Miles': '0.34',
    'OH DE Miles': '0.35',
  },
  '2370331': {
    Program: 'Palisades Rebuild',
    PIF: '535020',
    TD: '2370331',
    Circuit: 'NICHOLAS',
    Leader: 'Vince Cichoski',
    Region: 'North Coast',
    'Work Type': 'UG Install',
    'UG Miles': '0.29',
    'OH DE Miles': '0.06',
  },
  '2378418': {
    Program: 'Eaton Rebuild',
    PIF: '46497',
    TD: '2378418',
    Circuit: 'GORGE',
    Leader: 'Frank Cardosa',
    Region: 'Metro East',
    'Work Type': 'UG Install',
    'UG Miles': '0.00',
    'OH DE Miles': '0.00',
  },
  '2378432': {
    Program: 'Eaton Rebuild',
    PIF: '46500',
    TD: '2378432',
    Circuit: 'GORGE',
    Leader: 'Frank Cardosa',
    Region: 'Metro East',
    'Work Type': 'UG Install',
    'UG Miles': '0.00',
    'OH DE Miles': '0.00',
  },
  '2381687': {
    Program: 'Palisades Rebuild',
    PIF: '635047',
    TD: '2381687',
    Circuit: 'PLATEAU',
    Leader: 'Robert Flannery',
    Region: 'North Coast',
    'Work Type': 'UG Install',
    'UG Miles': '0.71',
    'OH DE Miles': '0.00',
  },
  '2381688': {
    Program: 'Palisades Rebuild',
    PIF: '635047',
    TD: '2381688',
    Circuit: 'PLATEAU',
    Leader: 'Robert Flannery',
    Region: 'North Coast',
    'Work Type': 'UG Install',
    'UG Miles': '0.72',
    'OH DE Miles': '0.00',
  },
  '': {
    Program: '',
    PIF: '',
    TD: '',
    Circuit: '',
    Leader: '',
    Region: '',
    'Work Type': '',
    'UG Miles': '',
    'OH DE Miles': '',
  },
} as const;

export default sceData;
